











































































































  import { Component, Vue,Watch } from "vue-property-decorator";
  import Sidebar from "../components/Sidebar.vue";
  import conactdetail from "../components/contact/contactDetail.vue";

  import TextMessage from "../components/contact/TextMessages.vue";
  import CallHistory from "../components/contact/CallHistory.vue";
  import NewContact from "../components/contact/NewContact.vue";
  import EditContact from '../components/contact/EditContact.vue';
  import BulkImportContats from '../components/contact/BulkImport_Contact.vue';
  import Alerts from "../views/Alerts.vue";

  import { store, StoreState } from "../store"; 
  import { mapState } from "vuex";
  import VueElementLoading from "vue-element-loading";  
  import { RotateSquare2 } from "vue-loading-spinner"; 
  import { fail } from "assert";
  import AES from "crypto-js/aes";
  import CryptoJS from "crypto-js";
  

  @Component({
    components: {
      Sidebar,
      conactdetail,
      TextMessage,
      CallHistory,
      NewContact,EditContact,
      RotateSquare2,
      VueElementLoading,
      Alerts,BulkImportContats
    },
    computed: {
      ...mapState({
        admin_loader: (state: StoreState) => state.dashboard.admin.admin_loader,
        userfirstname: (state: StoreState) => state.dashboard.userfirstname,
        'contact_Detail':(state: StoreState) => state.dashboard.contactdetail, 
        'contactstatusvm':(state: StoreState) => state.dashboard.contactstatusvm, 
        'selectedContact': (state: StoreState) => state.dashboard.selectedContact,
        'Number':(state: StoreState) => state.dashboard.newcontact_creat_Number, 
        'selectedContact_menu': (state: StoreState) => state.dashboard.selectedContact_menu,
        'session_timeout': (state: StoreState) => state.account.logout_status
      })
    },
    mounted: function() {
              this.GetAll_contacts();
         },
      beforeDestroy() {
          ////Befor destroy clear date values
           this.$store.commit('CHANGE_SELECTED_CONTACT', null);
        }
   
  })
  export default class Contacts extends Vue {  
    data() {
      return {
        contacts: [],
        fullNames: [],
        search_text: "",
        org_fullNames: [],
        retur_fullnae:[],
        noDataDisplay: false,
        show: false,
        contact_status: "",
        visible: false,
        person: "/img/icons/person_icons.png",
        person_detail: "/img/icons/Details icon@2x.png",
        createcontact:'',
        hidePopover: true,
        posTop: 0,
        contact_info:'',
        delete_status:'',//updatePublic,
        index_contact:'',
        Edit_ContactDetail:'',
        header_icon:false,
        temp_array:[],
        show_seachicon:false,
        menu_status:false,
        menustats_id:'',
        bulkimport_Status:false,
        contact_listloader:false
      };
    }



  @Watch ('selectedContact.imageUrl')
  SetImage()
  {
    //alert('selectedContact.imageUrl')  
    const id= (this as any).selectedContact._id
    this.$data.fullNames
      var found = this.$data.fullNames.find(function(element) {
          return element._id ==id;
        });
      found.imageUrl= (this as any).selectedContact.imageUrl;
  }

  
 @Watch ('selectedContact.first_name')
  SetName()
  {
    //alert('selectedContact.imageUrl')  
    const id= (this as any).selectedContact._id
    this.$data.fullNames
      var found = this.$data.fullNames.find(function(element) {
          return element._id ==id;
        });
      found.full_name=  `${(this as any).selectedContact.first_name} ${(this as any).selectedContact.last_name}`
  }
  @Watch ('selectedContact.last_name')
  SetLName()
  {
    //alert('selectedContact.imageUrl')  
    const id= (this as any).selectedContact._id;
    if(id!==null)
    this.$data.fullNames
      var found = this.$data.fullNames.find(function(element) {
          return element._id ==id;
        });
      found.full_name=  `${(this as any).selectedContact.first_name} ${(this as any).selectedContact.last_name}`
       
  }
  BulkImport(){
    this.$data.bulkimport_Status=true;
    this.$data.contact_status='';
        this.mouseLeave_2();
  }


  bulkimportevent(value:any){
    this.$data.bulkimport_Status=false;
    if(value=='refresh'){
      this.GetAll_contacts();
    }
  }
  
   maindivhover_2(){
       var d = document.getElementById('yourDivId_2');       
          d.style.visibility = "visible";//"hidden"  
    }
    mouseLeave_2(){
        var d = document.getElementById('yourDivId_2');       
         d.style.visibility ="hidden" ; 
    }

    search_inputclick()
      {
         var x = document.getElementById("input_searchicon");
          x.style.display = "none";
      }

    search_inputblur()
      {
        var x = document.getElementById("input_searchicon");
        if(this.$data.search_text.length!=0){
          x.style.display = "none";
        }
        else{
          x.style.display = "inline";
        }
      }
        
    focusInput() 
      { 
          document.getElementById("input_search").focus(); 
          var x = document.getElementById("input_searchicon");
          x.style.display = "none";
      } 

      hidediv(){
        this.$data.menu_status=false;
      }

      maindivhover(id,contact){
         //this.$store.commit("SELECTED_CONTACT_MENU", null);
       //  alert((this as any).selectedContact_menu)
       this.$store.commit("SELECTED_CONTACT_MENU",contact);
        if(this.$data.menustats_id=='')
        this.$data.menustats_id=id;//:this.$data.menustats_id;
         
        if(this.$data.menustats_id==id)
        {
            //this.$data.menu_status=true;
        }
        else{
          //this.$data.menustats_id=id;
            //this.$data.menu_status=false;
          var d = document.getElementById('yourDivId');       
          d.style.visibility = "hidden"  
        }
      }
     mouseLeave(){
        var d = document.getElementById('yourDivId');       
         d.style.visibility = "hidden"  
     }

      getPositionXY(element, contact) { 
        if(element == undefined)
        {
          element ='yourDivId';
        }
        var div = document.getElementById(element);   
        var rect = div.getBoundingClientRect();    
        console.log("Coordinates: " + rect.left + "px, " + rect.top +  "px");
        var d = document.getElementById('yourDivId');  
         if(this.$data.menustats_id==element)
       {
          d.style.position = "absolute";
          d.style.left = rect.left+190+'px';
         // d.style.top = rect.top-120+'px';
          if((this as any).selectedContact_menu.updatePublic){
             d.style.top = rect.top-133+'px';
          }
          else{
               d.style.top = rect.top-122+'px';
          }
       
          //this.$data.menu_status=true;
          d.style.visibility = "visible"  ;
         // this.$store.commit("SELECTED_CONTACT_MENU",contact);
        //   alert((this as any).selectedContact_menu)
         // visibility: hidden;
       }
       else{
        console.log('else'+ element)
        this.$data.menustats_id=element;
          //this.$data.menu_status=false;
        d.style.visibility = "hidden"  
       }

    } 
         

  created() {
     this.$data.contact_status=(this as any).contact_Detail?'text_message':'';
     if ((this as any ).contactstatusvm)
     {
        this.CALLHISTORY() ;
        this.$store.commit("SET_CONTACT_STATUS_VM", false);
     }
     this.GetAll_contacts();
  }

 
    get loger_Name(){    
			this.$data.notifications_open = true;
			var Login_User=AES.decrypt(decodeURI((this as any).$cookies.get('username')),"2r5u8x/A").toString(CryptoJS.enc.Utf8);
			Login_User=Login_User.substring(0,Login_User.indexOf('@'));
			return Login_User
        }

   GetAll_contacts() {
   
    this.$store.commit("SET_ADMIN_LOADER", true);
    this.$data.contact_listloader=true;

    this.$store.dispatch("getContacts").then(r => {
        this.$data.visible = true;
        this.$data.contacts = r.data.docs;
        let fullNames = r.data.docs.map(
          ({ first_name, last_name, _id, _rev,updatePublic,imageUrl }) => {
            return {
              full_name: `${first_name} ${last_name}`,
              _id: _id,
              _rev: _rev,
              updatePublic:updatePublic,
              imageUrl:imageUrl,
              code: first_name.charAt(0) + "" + last_name.charAt(0)
            };
          }
        );
        fullNames.sort(function(a, b) {
          const nameA = a.full_name.toLowerCase(),
            nameB = b.full_name.toLowerCase();
          if (nameA < nameB)
            //sort string ascending
            return -1;
          if (nameA > nameB) return 1;
          return 0; //default return value (no sorting)
        });
        const haveHashNum = [];
        const haveLetters = [];
        const haveNum = [];
        fullNames.map(o => {
          if (isNaN(o.full_name)) {
            if (o.full_name.match(/^\d/) ) {
              haveHashNum.push(o);
            } else {
              haveLetters.push(o);
            }
          } else {
            haveNum.push(o);
          }
        });
        fullNames = [];
        fullNames = [...haveLetters, ...haveNum, ...haveHashNum];
        this.$data.org_fullNames = [...fullNames];
        this.filterContacts(fullNames);
        this.$data.retur_fullnae=this.filterContacts(fullNames);;
        //this.$store.commit("SET_ADMIN_LOADER", false);
            this.$data.contact_listloader=false;

      })
      .catch(e => {
       // this.$store.commit("SET_ADMIN_LOADER", false);
        console.log(e);
      });
      
  }

 


  Newcontact_event(event) {  
    this.$store.commit("CHANGE_SELECTED_CONTACT", null);
    this.$data.contact_status = "";
    if (event == "refresh") {
      this.GetAll_contacts();
    }
  }


  searchNames() {
    //this.$data.show_seachicon=this.$data.search_text.length!=0?true:false;
    let fullNames = this.$data.org_fullNames.filter(obj => {
      return obj.full_name
        .toLowerCase()
        .includes(this.$data.search_text.toLowerCase());
    });
    this.filterContacts(fullNames);
  }

  filterContacts(fullNames) {
    if (fullNames.length > 0) {
      this.$data.noDataDisplay = false;
      let curr,
        next,
        collect = [];
      for (let j = 0; j < fullNames.length; j++) {
        const curr = fullNames[j].full_name.charAt(0).toUpperCase();
        if (j + 1 < fullNames.length) {
          const next = fullNames[j + 1].full_name.charAt(0).toUpperCase();
          if (curr && next) {
            if (curr === next) {
              collect.push(fullNames[j]);
            } else {
              collect.push(fullNames[j]);
              collect.push({
                full_name: fullNames[j + 1].full_name.charAt(0).toUpperCase(),
                class: "alphanum"
              });
            }
          }
        }
      }
      collect.push(fullNames[fullNames.length - 1]);
      collect.unshift({
        full_name: fullNames[0].full_name.charAt(0).toUpperCase(),
        class: "alphanum"
      });
      this.$data.fullNames = [...collect];
       var scrolldown;
 	    scrolldown = setTimeout(this.scroTobottom, 1000);
    } else {
      this.$data.noDataDisplay = true;
    }
  }

  scroTobottom(){  
    var kk=(this as any).selectedContact;
    if((this as any).selectedContact!=null) {
    var focs=(this as any).selectedContact._id;
      let el = document.getElementById(focs);  
                if(el!=null)
        el.scrollIntoView({ block: 'end'});  
    }
   
  }

  contact_header(er){
    this.$data.contact_status = er;
  }

  selectContact(index: any, data: any) {
    //alert('selectContact')
    this.$data.contact_status = "contact_detail";
    this.$store.commit('SET_NUMBER_BEING_CALLED', null);
    this.$data.header_icon=true;
    this.$store.commit('SET_FOCUSTEXT', '');
    this.$store.dispatch('getTextPermissions');
    const contact = this.$data.contacts[index];
    this.$data.contacts.forEach(element => {
      if (element._id == data._id) {
        this.$store.commit("CHANGE_SELECTED_CONTACT", element);
      }
    });
  }

  textMessage_m() {
    this.$data.contact_status = "text_message";
    //(this.$refs.textMessages as any).setSelectedNumber('bbbb');
  }
  CALLHISTORY() {
    this.$data.contact_status = "call_history";
  }
  CONTACT_DETAIL() {
    this.$data.contact_status = "contact_detail";
  }

   

  TextMsgEventHandel(event){
    this.$store.commit("NEW_CONTACT_CREATE_WITHNUMBER", event);
    this.$store.commit("NEW_CONTACT_CREATE_WITHNUMBER", this.formattedSearchTermNumber);
    this.newcontact();
   }

  get formattedSearchTermNumber() {
            let search_term = (this as any).Number;
            search_term = search_term.replace(/\D/g, '');
            if(search_term.length === 11 && search_term[0] === '1') {
                search_term = search_term.substring(1);
            }
            if(search_term.length === 10) {
                this.$data.Createcontact_Byname={Fname:'' ,Lname:''  };
                return (this as any).formatPhoneNumber(search_term);
            }
            else {
                return '';
            }
        }


  newcontact() {
    this.$data.header_icon=false;
    this.$store.commit("CHANGE_SELECTED_CONTACT", null);
    this.$data.contact_status = "new_contact";
  }
  
 
    //Edit fun from scrollbar even
    editContact(contact_info)
        {
        this.$data.hidePopover = true;
        //const contact = this.$data.contacts[index];
        this.$data.contacts.forEach(element => {
          if (element._id == contact_info._id) {
            this.$data.Edit_ContactDetail=element;
            this.$store.commit("CHANGE_SELECTED_CONTACT", element);  
             var d = document.getElementById('yourDivId');  
              d.style.visibility = "hidden";
               this.$store.commit("SELECTED_CONTACT_MENU", null);    
            this.Edit_contactb();
          }
        });  
      this.edit_process();
    }
    
    //Edit Function from contactdetail page
    Edit_contactb(){
      this.$data.Edit_ContactDetail=(this as any).selectedContact;
      this.edit_process();
     }

     //Edit contact
    edit_process(){
        this.$data.contact_status='edit_contact';
         if(this.$data.Edit_ContactDetail.numbers.mobile.number!=''){
          var  Mobile;
            if(this.$data.Edit_ContactDetail && this.$data.Edit_ContactDetail.numbers && this.$data.Edit_ContactDetail.numbers.mobile && this.$data.Edit_ContactDetail.numbers.mobile.number) {
                Mobile= this.formatPhoneNumber(this.$data.Edit_ContactDetail.numbers.mobile.number);
            }
            else {Mobile='';}
         }
         else {Mobile='';}
        if(this.$data.Edit_ContactDetail.numbers.main[0]!=''){
            var MainNumber;
            if(this.$data.Edit_ContactDetail && this.$data.Edit_ContactDetail.numbers && this.$data.Edit_ContactDetail.numbers.main && this.$data.Edit_ContactDetail.numbers.main.length > 0) {
                    MainNumber= this.formatPhoneNumber(this.$data.Edit_ContactDetail.numbers.main[0]);
            }
            else {  MainNumber='';     }
        }
       else {  MainNumber='';     }
        this.$data.EditForm={
            firstName   :  this.$data.Edit_ContactDetail.first_name ,
            lastName    :  this.$data.Edit_ContactDetail.last_name , 
            comyName    :  this.$data.Edit_ContactDetail.compny_name , 
            main        :  MainNumber,
            extension   :  this.$data.Edit_ContactDetail.extension,   
            mobile      :  Mobile,
            customerid  :  this.$data.Edit_ContactDetail.custermerid , 
            addline1    :  this.$data.Edit_ContactDetail.address.line1 ,  
            addline2    :  this.$data.Edit_ContactDetail.address.line2 , 
            city        :  this.$data.Edit_ContactDetail.address.city , 
            state       :  this.$data.Edit_ContactDetail.address.state , 
            zip         :  this.$data.Edit_ContactDetail.address.zip , 
             email      :  this.$data.Edit_ContactDetail.email[0] ,
            Id          :  this.$data.Edit_ContactDetail.private?0:1,
            updatePublic:  this.$data.Edit_ContactDetail.updatePublic
        }
        this.$store.commit("EDIT_CONTACT_UPDATE",true);
        this.$store.commit("SHOW_CONTACT_LIST", false);
        this.$store.commit("SHOW_CONTACT_DETAIL", false);
        this.$store.commit("SET_SELECTED_CONTACTS", this.$data.EditForm);
       // (this.$refs.editform as any).clearError();
    }
     
     
     formatPhoneNumber(phoneNumber: any) {
            if(typeof phoneNumber === "number") {
                phoneNumber = phoneNumber.toString();
            }
            //This regex is based off the format of phone numbers
            //as they are returned in the contact list by the Kazoo API.
            //Link: https://github.com/2600hz/kazoo/blob/master/applications/crossbar/doc/contact_list.md
            //If the Hellospoke database uses a different format will adjust
            //the pattern accordingly
            const re = /(?:\+1)?(\d{3})(\d{3})(\d{4})/;
            const matches = phoneNumber.match(re);
            if(matches === null) {
                    console.log("The phone number " + phoneNumber + " could not be parsed");
                return "Invalid number";
            }
            return `(${matches[1]}) ${matches[2]}-${matches[3]}`;
        }

    deleteContact(name) {
      this.$data.contact_info = name;
      var d = document.getElementById('yourDivId');     
      d.style.visibility = "hidden";
      this.$store.commit("SELECTED_CONTACT_MENU", null);    
      var self=this;
      this['$iziToast'].question({  
        overlay: true,
        timeout: false,
        toastOnce: true, 
       // id: 'question',
        title: 'Are you sure you want to delete?',
        //message: 'Are you sure you want to delete??', 
        position: 'center',
        icon: '',
        buttons: [
            ['<button><b>YES</b></button>', function (instance, toast) {
                   self.delet_confer(instance, toast)
            }, true],
            ['<button>NO</button>', function (instance, toast) {
                instance.hide({ transitionOut: 'fadeOut' }, toast);
            }]
        ]
      });
    }

  delet_confer(instance, toast){
     instance.hide({ transitionOut: 'fadeOut' }, toast);
      var data=this.$data.contact_info;
      this.$store.dispatch('deleteContact', { id: data._id, rev:data._rev}) 
         .then(r => {
    		  var index = this.$data.fullNames.map(function(item){
    				return item._id
          }).indexOf( data._id);
          this.$data.fullNames.splice(index, 1);
          this.GetAll_contacts();

          if((this as any).selectedContact._id==data._id){
             this.$store.commit("CHANGE_SELECTED_CONTACT", null);
             this.$data.contact_status = "";
          }
          var scontact=(this as any).selectedContact;
    		  this['$iziToast'].success({message: 'Deleted successfully.'});
          })
          .catch(() => {  });
  }
}
